<template>
    <div id="SelectorWidget">
        <div class="header_container">
            <h1>Select your resources</h1>
            <h3>
                Filter by country and/or level of education by using the drop down menus below.
            </h3>
        </div>
        <div class="selector_container">
            <div class="selector">
                <img :src="require('../assets/by_country.svg')" alt="placeholder image" />
                <div class="selector_text">
                    <h4>Look at the resources by country</h4>
                </div>
                <div class="selector_dropdown">
                    <DropdownWidget :placeholder="'Select Country'" :selected="selected[0]"
                        :options="courseCountryOptions" @setSelected="(data) => (selected[0] = data)" />
                </div>
            </div>
            <div class="vr"></div>
            <div class="selector">
                <img :src="require('../assets/by_level_of_education.svg')" alt="placeholder image" />
                <div class="selector_text">
                    <h4>Look at the resources by level of education </h4>
                </div>
                <div class="selector_dropdown">
                    <DropdownWidget :placeholder="'Select Level'" :selected="selected[1]" :options="courseLevelOptions"
                        @setSelected="(data) => (selected[1] = data)" />
                </div>
            </div>
        </div>
        <div class="results_container">
            <div class="results_title">
                <h1>Search results</h1>
            </div>
            <div class="results_list">
                <ul v-for="(results, index) in results" :key="index">
                    <span>
                        <li><a :href="results.courseLink" target="_blank">
                                <span>{{ results.courseName }}</span>

                                <span v-if="results.courseCountry != null"> | </span>
                                <span v-if="results.courseCountry != null">{{ results.courseCountry }}</span>

                                <span v-if="results.courseLevel != null"> | </span>
                                <span v-if="results.courseLevel != null">{{ results.courseLevel }}</span>
                            </a></li>
                    </span>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import DropdownWidget from './DropdownWidget.vue'
import { ref, computed } from 'vue'
export default {
    name: "SelectorWidget",
    components: {
        DropdownWidget
    },
    setup() {
        var selected = ref([null, null])

        var courseData = ref(
            [
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA portal",
                    "courseLink": "https://www.open.edu/openlearncreate/course/index.php?categoryid=568"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA All Africa (in Arabic)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2198"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA All Africa (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA All Africa (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2046"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA All Africa (in Swahili)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2199"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA Early reading course (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=3287"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA Making teacher education relevant for 21st Century Africa course (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2745"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA Making teacher education relevant for 21st Century Africa course (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=3784"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESSA: Teaching Primary Life Skills",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESSA: Teaching Primary Numeracy",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESSA: Teaching Primary Literacy",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESSA: Teaching Primary Social Studies and the Arts",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESSA: Teaching Primary Science",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ALL AFRICA",
                    "courseLevel": "SECONDARY",
                    "courseName": "TESSA: Teaching Secondary Science",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ANGOLA",
                    "courseLevel": null,
                    "courseName": "TESSA Angola (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2095"
                },
                {
                    "courseCountry": "BENIN",
                    "courseLevel": null,
                    "courseName": "TESSA Benin (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2094"
                },
                {
                    "courseCountry": "BOTSWANA",
                    "courseLevel": null,
                    "courseName": "TESSA Botswana (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2093"
                },
                {
                    "courseCountry": "BURKINA FASO",
                    "courseLevel": null,
                    "courseName": "TESSA Burkina Faso (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2096"
                },
                {
                    "courseCountry": "BURUNDI",
                    "courseLevel": null,
                    "courseName": "TESSA Burundi (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2091"
                },
                {
                    "courseCountry": "CAMEROUN",
                    "courseLevel": null,
                    "courseName": "TESSA Cameroun (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2090"
                },
                {
                    "courseCountry": "CAP-VERT",
                    "courseLevel": null,
                    "courseName": "TESSA Cap-Vert (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2089"
                },
                {
                    "courseCountry": "COMORES",
                    "courseLevel": null,
                    "courseName": "TESSA Comores (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2086"
                },
                {
                    "courseCountry": "COTE D'IVOIRE",
                    "courseLevel": null,
                    "courseName": "TESSA Cote d'Ivoire (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2083"
                },
                {
                    "courseCountry": "DJIBOUTI",
                    "courseLevel": null,
                    "courseName": "TESSA Djibouti (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2082"
                },
                {
                    "courseCountry": "ERITREA",
                    "courseLevel": null,
                    "courseName": "TESSA Eritrea (in Arabic)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2080"
                },
                {
                    "courseCountry": "ETHIOPIA",
                    "courseLevel": null,
                    "courseName": "TESSA Ethiopia (in English)",
                    "courseLink": " https://www.open.edu/openlearncreate/course/view.php?id=2079"
                },
                {
                    "courseCountry": "GABON",
                    "courseLevel": null,
                    "courseName": "TESSA Gabon (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2078"
                },
                {
                    "courseCountry": "THE GAMBIA",
                    "courseLevel": null,
                    "courseName": "TESSA The Gambia (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2052"
                },
                {
                    "courseCountry": "GHANA",
                    "courseLevel": null,
                    "courseName": "TESSA Ghana (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2077"
                },
                {
                    "courseCountry": "GHANA",
                    "courseLevel": "SECONDARY",
                    "courseName": "OpenSTEM Africa",
                    "courseLink": "https://www.open.edu/openlearncreate/course/index.php?categoryid=420"
                },
                {
                    "courseCountry": "GUINEE  ",
                    "courseLevel": null,
                    "courseName": "TESSA Guinee (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2076"
                },
                {
                    "courseCountry": "GUINEE EQUATORIALE",
                    "courseLevel": null,
                    "courseName": "TESSA Guinee Equatoriale (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2081"
                },
                {
                    "courseCountry": "GUINEE-BISSAU",
                    "courseLevel": null,
                    "courseName": "TESSA Guinee-Bissau",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2075"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Assam resources (in Assamese)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1931"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Bihar resources (in Hindi)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1934"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Madhya Pradesh resources (in Hindi)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1930"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Uttar Pradesh resources (in Hindi)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1929"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Karnataka resources (in Kannada)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1935"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Odisha resources (in Odia)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1933"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: West Bengal resources (in Bengali)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1932"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: All India resources (in Hindi)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1928"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: All India resources (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India MOOC on OLC (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2470"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in Hindi)",
                    "courseLink": "https://www.youtube.com/watch?v=8GjvTuiGXI4&list=PLLjfVZ89nnNIDn_dPiumO1kamfpvSUUht"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in Assamese)",
                    "courseLink": "https://www.youtube.com/watch?v=C5S3s2G7_tQ&list=PLLjfVZ89nnNI8ZiIxNzEvm-kp-g8uRZ_o"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in Kannada)",
                    "courseLink": "https://www.youtube.com/watch?v=J3dSy30h4Tk&list=PLLjfVZ89nnNKbLH1aZjf7u4S277AhLlft&index=1"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in Odia)",
                    "courseLink": "https://www.youtube.com/watch?v=sXgwzfZbp4g&list=PLLjfVZ89nnNJz667msJ6JjCxE-y5vG5od"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in Bengali)",
                    "courseLink": "https://www.youtube.com/watch?v=Ygw7FBykCUA&list=PLLjfVZ89nnNI92t-AKami4w5Ird4koEF8"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": null,
                    "courseName": "TESS-India: Videos (in English)",
                    "courseLink": "https://www.youtube.com/watch?v=yMJCzEbTy34&list=PLLjfVZ89nnNI7lEZRdanOTVxzuosUW0Bp"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESS-India: Teaching Elementary English",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESS-India: Teaching Elementary Maths",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESS-India: Teaching Elementary Science",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESS-India: Teaching Elemntary Language and Literacy",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "TESS-India: School Leadership (Primary)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "SECONDARY",
                    "courseName": "TESS-India: Teaching Secondary English",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "SECONDARY",
                    "courseName": "TESS-India: Teaching Secondary Maths",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "SECONDARY",
                    "courseName": "TESS-India: Teaching Secondary Science",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "INDIA",
                    "courseLevel": "SECONDARY",
                    "courseName": "TESS-India: School Leadership (Secondary)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1911"
                },
                {
                    "courseCountry": "KENYA",
                    "courseLevel": null,
                    "courseName": "TESSA Kenya (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2074"
                },
                {
                    "courseCountry": "LESOTHO",
                    "courseLevel": null,
                    "courseName": "TESSA Lesotho (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2073"
                },
                {
                    "courseCountry": "LIBERIA",
                    "courseLevel": null,
                    "courseName": "TESSA Liberia (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2072"
                },
                {
                    "courseCountry": "MADAGASCAR",
                    "courseLevel": null,
                    "courseName": "TESSA Madagascar (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2071"
                },
                {
                    "courseCountry": "MALAWI",
                    "courseLevel": null,
                    "courseName": "TESSA Malawi (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2070"
                },
                {
                    "courseCountry": "MALI",
                    "courseLevel": null,
                    "courseName": "TESSA Mali (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2069"
                },
                {
                    "courseCountry": "MAURITANIA",
                    "courseLevel": null,
                    "courseName": "TESSA Mauritania (in Arabic)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2068"
                },
                {
                    "courseCountry": "MAURITIUS",
                    "courseLevel": null,
                    "courseName": "TESSA Mauritius (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2067"
                },
                {
                    "courseCountry": "MOZAMBIQUE",
                    "courseLevel": null,
                    "courseName": "TESSA Mozambique (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2066"
                },
                {
                    "courseCountry": "MYANMAR",
                    "courseLevel": "HIGHER EDUCATION",
                    "courseName": "TIDE",
                    "courseLink": "https://www.open.edu/openlearncreate/course/index.php?categoryid=479"
                },
                {
                    "courseCountry": "NAMIBIA",
                    "courseLevel": null,
                    "courseName": "TESSA Namibia (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2065"
                },
                {
                    "courseCountry": "NIGER  ",
                    "courseLevel": null,
                    "courseName": "TESSA Niger (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2064"
                },
                {
                    "courseCountry": "NIGERIA",
                    "courseLevel": null,
                    "courseName": "TESSA Nigeria (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2063"
                },
                {
                    "courseCountry": "REPUBLIQUE CENTRAFRICAINE",
                    "courseLevel": null,
                    "courseName": "TESSA Republique Centrafricaine (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2088"
                },
                {
                    "courseCountry": "REPUBLIQUE DEOMCRATIQUE DU CONGO",
                    "courseLevel": null,
                    "courseName": "TESSA Republique Democratique du Congo (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2084"
                },
                {
                    "courseCountry": "REPUBLIQUE DU CONGO",
                    "courseLevel": null,
                    "courseName": "TESSA Republique du Congo (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2085"
                },
                {
                    "courseCountry": "RWANDA",
                    "courseLevel": null,
                    "courseName": "TESSA Rwanda (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2061"
                },
                {
                    "courseCountry": "SAO TOME AND PRINCIPE",
                    "courseLevel": null,
                    "courseName": "TESSA Sao Tome and Principe (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2060"
                },
                {
                    "courseCountry": "SENEGAL",
                    "courseLevel": null,
                    "courseName": "TESSA Senegal (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2059"
                },
                {
                    "courseCountry": "SEYCHELLES",
                    "courseLevel": null,
                    "courseName": "TESSA Seychelles (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2058"
                },
                {
                    "courseCountry": "SIERRA LEONE",
                    "courseLevel": "PRIMARY",
                    "courseName": "GATE",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=7885"
                },
                {
                    "courseCountry": "SIERRA LEONE",
                    "courseLevel": "NON-FORMAL EDUCATION",
                    "courseName": "GATE",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=7885"
                },
                {
                    "courseCountry": "SIERRA LEONE",
                    "courseLevel": null,
                    "courseName": "TESSA Sierra Leone (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2057"
                },
                {
                    "courseCountry": "SOMALIA",
                    "courseLevel": null,
                    "courseName": "TESSA Somalia (in Arabic)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2056"
                },
                {
                    "courseCountry": "SOUTH AFRICA",
                    "courseLevel": null,
                    "courseName": "TESSA South Africa (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2055"
                },
                {
                    "courseCountry": "SOUTH SUDAN",
                    "courseLevel": null,
                    "courseName": "TESSA South Sudan (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2120"
                },
                {
                    "courseCountry": "SUDAN",
                    "courseLevel": null,
                    "courseName": "TESSA Sudan (in Arabic)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2054"
                },
                {
                    "courseCountry": "SWAZILAND",
                    "courseLevel": null,
                    "courseName": "TESSA Swaziland (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2053"
                },
                {
                    "courseCountry": "TANZANIA",
                    "courseLevel": null,
                    "courseName": "TESSA Tanzania (in Swahili)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=1952"
                },
                {
                    "courseCountry": "TCHAD",
                    "courseLevel": null,
                    "courseName": "TESSA Tchad (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2087"
                },
                {
                    "courseCountry": "TOGO",
                    "courseLevel": null,
                    "courseName": "TESSA Togo (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2051"
                },
                {
                    "courseCountry": "UGANDA",
                    "courseLevel": null,
                    "courseName": "TESSA Uganda (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2050"
                },
                {
                    "courseCountry": "WORLDWIDE",
                    "courseLevel": null,
                    "courseName": "Inclusive Teaching and Learning course (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=6453"
                },
                {
                    "courseCountry": "WORLDWIDE",
                    "courseLevel": null,
                    "courseName": "Inclusive Teaching and Learning course (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=6733"
                },
                {
                    "courseCountry": "WORLDWIDE",
                    "courseLevel": null,
                    "courseName": "Creating an Inclusive School course (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=6505"
                },
                {
                    "courseCountry": "WORLDWIDE",
                    "courseLevel": null,
                    "courseName": "Creating an Inclusive School course (in French)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=8142"
                },
                {
                    "courseCountry": "ZAMBIA",
                    "courseLevel": null,
                    "courseName": "TESSA Zambia (in English)",
                    "courseLink": " https://www.open.edu/openlearncreate/course/view.php?id=2047"
                },
                {
                    "courseCountry": "ZAMBIA",
                    "courseLevel": "PRIMARY",
                    "courseName": "ZEST",
                    "courseLink": "https://www.open.edu/openlearncreate/course/index.php?categoryid=450"
                },
                {
                    "courseCountry": "ZIMBABWE",
                    "courseLevel": null,
                    "courseName": "TESSA Zimbabwe (in English)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2048"
                },
                {
                    "courseCountry": "ZIMBABWE",
                    "courseLevel": "PRIMARY",
                    "courseName": "IGATE (foundational skills in literacy and numeracy)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ZIMBABWE",
                    "courseLevel": "NON-FORMAL EDUCATION",
                    "courseName": "IGATE (foundational skills in literacy and numeracy)",
                    "courseLink": "https://www.open.edu/openlearncreate/course/view.php?id=2042"
                },
                {
                    "courseCountry": "ZIMBABWE",
                    "courseLevel": "NON-FORMAL EDUCATION",
                    "courseName": "SAGE",
                    "courseLink": "https://www.open.edu/openlearncreate/course/index.php?categoryid=602"
                }
            ]
        )

        var courseCountryOptions = computed(() => {
            var arr = [...new Set(courseData.value.map((x) => x.courseCountry))]

            if (arr.indexOf(null) != -1) {
                arr.splice(arr.indexOf(null), 1);
            }

            arr = arr.map((x) => { return { label: x } })

            return arr.sort((a, b) => a.label.localeCompare(b.label));
        })

        var courseLevelOptions = computed(() => {
            var arr = [...new Set(courseData.value.map((x) => x.courseLevel))]

            if (arr.indexOf(null) != -1) {
                arr.splice(arr.indexOf(null), 1);
            }

            return arr.map((x) => { return { label: x } })
        })

        var results = computed(() => {
            //Set filter object
            var filter = {};
            if (selected.value[0] != null) {
                filter.courseCountry = selected.value[0].label;
            }
            if (selected.value[1] != null) {
                filter.courseLevel = selected.value[1].label;
            }

            //Filter results using filter object
            var filteredResults = courseData.value.filter(function (item) {
                for (var key in filter) {
                    if (item[key] === undefined || item[key] != filter[key]) {
                        return false;
                    }
                }
                return true;
            });

            return filteredResults;
        })


        return {
            selected,
            courseData,
            courseLevelOptions,
            courseCountryOptions,
            results
        }
    }
}
</script>

<style scoped>
.header_container h1 {
    margin: 10px 0px 2px 10px;
    font-size: 2em;
}

.header_container h3 {
    font-weight: 100;
    font-size: 1.2em;
    margin: 1em 1.4em 1em 1.4em;
}

.selector h4 {
    font-size: 1.4em;
    text-align: center;
    margin: 10px;
}

#SelectorWidget {
    background: #d7e4ee;
    border: #1f4a9b solid 2px;
}

.header_container {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.selector_container {
    display: flex;
    flex-direction: row;
}

.selector_dropdown {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.results_container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 10px 10px 10px;
}

.results_list {
    height: 200px;
    width: 100%;
    background-color: #ffff;
    overflow: auto;
}

.selector {
    display: flex;
    flex-direction: column;
    padding: 10px 10px 10px 10px;
    flex: 1 1 50%;
    align-items: center;
}

.selector_text {
    margin-top: auto;
}

.selector img {
    width: 128px;
    height: 128px;
}

.vr {
    border-right: 2px solid #1f4a9b;
}

/* Results */
.results_list ul {
    background: #fff;
    color: #000;
    padding: 0px 0px;
    margin: 0px;
    width: 100%;
    list-style: none;
    box-sizing: border-box;
}

.results_list li {
    cursor: pointer;
}

.results_list ul li a {
    padding: 5px;
    display: block;
    font-size: 0.8em !important;
    text-decoration: none;
    color: #000;
}

.results_list a:visited {
    color: #000;
    text-decoration: none;
    outline: none;
}

.results_list a:hover {
    color: #5d4617;
    background-color: rgba(0, 0, 0, 0.05);
}
</style>